<template>
  <div class="mb-13">
    <div class="text-xl font-bold text-text leading-tight mb-8 flex items-center">
      <AssetGroupIcon :asset-type="group.properties.type"
                      class="mr-4 p-2"
                      style="width:2.4rem;height: 2.4rem;"/>
      {{ groupName(group.properties.type) }}
    </div>
    <div class="asset-list-grid th">
      <div></div>
      <div class="text-left" @click="$emit('sort','ticker')">
        {{ $t('ticker') }}
        <IconArrow v-if="displaySortArrow('ticker')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'ticker'  ? 'up':'down'"/>
      </div>
      <div class="text-left" @click="$emit('sort','name')">
        {{ $t('name') }}
        <IconArrow v-if="displaySortArrow('name')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'name'  ? 'up':'down'"/>
      </div>
      <div @click="$emit('sort','profit_percent_day')">
        {{ $t('forDay') }}, %
        <IconArrow v-if="displaySortArrow('profit_percent_day')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'profit_percent_day'  ? 'up':'down'"/>
      </div>
      <div @click="$emit('sort','profit_percent')">
        {{ $t('forAll') }}, %
        <IconArrow v-if="displaySortArrow('profit_percent')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'profit_percent'  ? 'up':'down'"/>
      </div>
      <div @click="$emit('sort','amount')">
        {{ $t('amount') }}
        <IconArrow v-if="displaySortArrow('amount')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'amount'  ? 'up':'down'"/>
      </div>
      <div @click="$emit('sort','price')">
        {{ $t('currentPrice') }}
        <IconArrow v-if="displaySortArrow('price')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'price'  ? 'up':'down'"/>
      </div>
      <div @click="$emit('sort','sum')">
        {{ $t('price') }}
        <IconArrow v-if="displaySortArrow('sum')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'sum'  ? 'up':'down'"/>
      </div>
      <div @click="$emit('sort','profit_absolute')">
        {{ $t('profit') }}
        <IconArrow v-if="displaySortArrow('profit_absolute')" class="ml-1 inline-block"
                   :direction="group.sort_by === 'profit_absolute'  ? 'up':'down'"/>
      </div>
      <div></div>
    </div>
    <div class="divide-y divide-border">
      <InvestmentAssetItem v-for="(item,i) in group.assets"
                           :key="i"
                           :asset="item"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import InvestmentAssetItem
  from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/InvestmentAssetItem";
import AssetGroupIcon from "@/components/common/Investments/AssetGroupIcon";
import IconArrow from "@/components/icons/IconArrow";

export default {
  name: "InvestmentAssetsGroup",
  components: {IconArrow, AssetGroupIcon, InvestmentAssetItem},
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
  },
  methods: {
    displaySortArrow(sort_field) {
      return sort_field === this.group.sort_by || `-${sort_field}` === this.group.sort_by
    },
    groupName(type) {
      switch (type) {
        case 1:
          return this.$t('stocks')
        case 2:
          return this.$t('funds')
        case 3:
          return this.$t('bonds')
        case 5:
          return this.$t('other')
      }
    },
    isItemCurrencyAndSpaceDefaultCurrency(item) {
      let portfolio_curr_code = this.current_portfolio.data.currency,
          item_curr_code = item.instrument.currency;
      return portfolio_curr_code === item_curr_code;
    }
  },
  i18n: {
    messages: {
      en: {
        stocks: 'Stocks',
        funds: 'Funds',
        bonds: 'Bonds',
        other: 'Other',
        ticker: 'Ticker',
        name: 'Name',
        forDay: 'For day',
        forAll: 'All time',
        amount: 'Amount',
        currentPrice: 'Current price',
        price: 'Values',
        profit: 'Profit'

      },
      ru: {
        stocks: 'Акции',
        funds: 'Облигации',
        bonds: 'Фонды',
        ticker: 'Тикер',
        other: 'Другое',
        name: 'Название',
        forDay: 'За день',
        forAll: 'За все время',
        amount: 'Кол-во',
        currentPrice: 'Текущая цена',
        price: 'Стоимость',
        profit: 'Прибыль'
      }
    }
  }
}
</script>

<style lang="scss">
.asset-list-grid {
  @apply grid col-gap-4;
  grid-template-columns:2.4rem 6.6% 20% 9.7% 11.4% 5.6% 12.5% 13.6% 8.8% auto;

  &.th {
    @apply -mx-6 px-6 rounded bg-bg py-4 text-sm text-text-ternary text-right;

    div {
      @apply cursor-pointer;
      &:first-child,
      &:last-child {
        @apply cursor-default;
      }
    }
  }
}
</style>